import { useCallback, useEffect } from 'react';

const noop = () => null;

const useOutsideClick = ({ node, onOutsideClick, onInsideClick, isOpen }) => {
  onInsideClick = onInsideClick || noop;

  const handleClick = useCallback(
    (e) => {
      const current = !!node && !!node.current ? node.current : null;
      if (!current) return;

      if (current.contains(e.target)) {
        // inside click
        onInsideClick && onInsideClick();
        return;
      }
      // outside click
      onOutsideClick();
    },
    [node, onInsideClick, onOutsideClick]
  );

  const attachDocumentEventListener = useCallback(
    () => document.addEventListener('mousedown', handleClick),
    [handleClick]
  );
  const removeDocumentEventListener = useCallback(
    () => document.removeEventListener('mousedown', handleClick),
    [handleClick]
  );

  useEffect(() => {
    if (isOpen) {
      attachDocumentEventListener();
    } else {
      removeDocumentEventListener();
    }

    return () => {
      removeDocumentEventListener();
    };
  }, [isOpen, attachDocumentEventListener, removeDocumentEventListener]);
};

export default useOutsideClick;
